import React from "react";

export default function VerifyProfileModal({
  isOpen,
  onClose,
  user,
  fallbackImageSrc,
  onApprove,
  onReject,
}) {
  if (!isOpen) return null;

  const imageSrc = user?.imageUrl || fallbackImageSrc;
  const userName = user
    ? [user.firstName, user.lastName].filter(Boolean).join(" ") || "User"
    : "User";

  return (
    <div
      className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4"
      role="dialog"
      aria-modal="true"
      aria-labelledby="verify-modal-title">
      <div className="bg-white rounded-xl shadow-xl w-full max-w-md max-h-[90vh] overflow-y-auto relative">
        <button
          type="button"
          onClick={onClose}
          className="absolute top-3 right-3 text-gray-500 hover:text-gray-800 p-1 rounded"
          aria-label="Close">
          ✕
        </button>
        <div className="p-4 sm:p-6">
          <h2
            id="verify-modal-title"
            className="text-lg sm:text-xl font-bold mb-4 pr-8">
            Verify User Profile Pic
          </h2>
          {user && (
            <p className="text-sm text-gray-600 mb-2">
              {userName}
            </p>
          )}
          <div className="w-full min-h-[200px] sm:min-h-[280px] flex items-center justify-center bg-gray-100 rounded-lg overflow-hidden">
            {imageSrc ? (
              <img
                src={imageSrc}
                alt={`Profile of ${userName}`}
                className="max-w-full max-h-80 object-contain"
              />
            ) : (
              <span className="text-gray-400 text-sm">No image</span>
            )}
          </div>
          <div className="flex flex-wrap justify-end gap-2 mt-4 pt-4 border-t border-gray-200">
            <button
              type="button"
              onClick={onClose}
              className="px-4 py-2 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300 text-sm font-medium">
              Cancel
            </button>
            <button
              type="button"
              onClick={() => {
                onApprove?.(user);
                onClose();
              }}
              className="px-4 py-2 bg-green-500 text-white rounded-lg hover:bg-green-600 text-sm font-medium">
              Approve
            </button>
            <button
              type="button"
              onClick={() => {
                onReject?.(user);
                onClose();
              }}
              className="px-4 py-2 bg-red-500 text-white rounded-lg hover:bg-red-600 text-sm font-medium">
              Reject
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
